import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0409d3b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "node-badge-card"
}
const _hoisted_2 = { class: "node-badge-title color-purple" }
const _hoisted_3 = { class: "color-dark-gray" }

import { computed } from "vue";
import i18n from "@/core/i18n/i18n";
import NodeConditionRows from "@/flow/components/vue-flow/NodeConditionRows.vue";
import { summarizeStepFilter } from "@/flow/utils/stepInputSummary";

interface IProps {
  step: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NodeFilterSummary',
  props: {
    step: {}
  },
  setup(__props: any) {

const props = __props;
const { t } = i18n.global;

const rows = computed(() => summarizeStepFilter(props.step));

return (_ctx: any,_cache: any) => {
  return (rows.value.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)("Flow.StepFilter")), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)("Flow.FilterGate")), 1),
        _createVNode(NodeConditionRows, { rows: rows.value }, null, 8, ["rows"])
      ]))
    : _createCommentVNode("", true)
}
}

})